import template from './recapResponseForm.html';
import controller from './recapResponseForm.controller';

let formComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    formResponseSet: '<',
  }
};

export default formComponent;
